import { observer } from "mobx-react-lite";

import { MESSAGE_TYPES, MessageType } from "../../types";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface RoleSelectorProps {
  selected: MessageType;
  onSelect: (type: MessageType) => void;
  readonly?: boolean;
  mode?: "batch" | "chat";
}

const RoleSelector = ({
  selected,
  onSelect,
  readonly = false,
  mode = "batch",
}: RoleSelectorProps) => {
  const types =
    mode === "chat" ? MESSAGE_TYPES.filter(type => type !== "placeholder") : MESSAGE_TYPES;

  const formatValue = (value: string) =>
    value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

  return (
    <Select value={selected} onValueChange={onSelect} disabled={readonly}>
      <SelectTrigger className="h-7 w-auto justify-start gap-1 border-transparent bg-transparent px-2 text-sm font-medium text-gray-600 shadow-none ring-0 transition-colors hover:bg-gray-100 hover:text-gray-900 focus:ring-1 focus:ring-gray-200 data-[state=open]:bg-gray-100 data-[placeholder]:text-gray-600">
        <SelectValue placeholder={formatValue(selected)} />
      </SelectTrigger>
      <SelectContent className="rounded-lg border-gray-200 p-1 shadow-lg">
        {types.map(type => (
          <SelectItem
            key={type}
            value={type}
            className="rounded-md px-2 py-1.5 text-sm text-gray-700 hover:bg-gray-100"
          >
            {formatValue(type)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default observer(RoleSelector);
